<form [formGroup]="personalDetailsForm()" novalidate>
    <ap-grid-row class="ap-display-block ap-margin-bottom-2">
        <ap-grid-col [sm]="12">
            <ap-radio-group
                [control]="personalDetailsForm().controls['gender'] | apFormControl"
                [description]="'personal.details.gender.label' | apKeyOverride: contentKeyMap() | apContent"
                [messages]="genderErrorMessages"
                [inline]="true"
                data-testid="gender"
            >
                @for (option of genderOptions; track option) {
                    <ap-radio-button
                        [label]="option.content | apKeyOverride: contentKeyMap() | apContent"
                        formControlName="gender"
                        [value]="option.value"
                        name="gender"
                        data-testid="gender-button"
                    >
                    </ap-radio-button>
                }
            </ap-radio-group>
        </ap-grid-col>
        <ap-grid-col [sm]="6">
            <ap-input
                [label]="'personal.details.firstNames.label' | apKeyOverride: contentKeyMap() | apContent"
                name="firstNames"
                autocomplete="given-name"
                [messages]="firstNamesErrorMessages"
                (hasDiacritics)="diacriticsChange($event, 'firstNames')"
                apDiacriticsNormalizeFormValue
                formControlName="firstNames"
                [trim]="true"
                data-testid="first-names"
            >
            </ap-input>
        </ap-grid-col>
        <ap-grid-col [sm]="3">
            <ap-input
                [label]="'personal.details.givenName.label' | apKeyOverride: contentKeyMap() | apContent"
                name="givenName"
                autocomplete="nickname"
                (hasDiacritics)="diacriticsChange($event, 'givenName')"
                apDiacriticsNormalizeFormValue
                formControlName="givenName"
                [messages]="givenNameErrorMessages"
                [trim]="true"
                data-testid="given-name"
            >
            </ap-input>
        </ap-grid-col>
        <ap-grid-col [sm]="3">
            <ap-initials-input
                [label]="'personal.details.initials.label' | apKeyOverride: contentKeyMap() | apContent"
                name="initials"
                formControlName="initials"
                [messages]="initialsErrorMessages"
                data-testid="initials"
            >
            </ap-initials-input>
        </ap-grid-col>
    </ap-grid-row>
    @if (personalDetailsForm().hasError('firstnamesMismatch')) {
        <ap-grid-row>
            <ap-grid-col [md]="12">
                <ap-notification status="error" data-testid="mismatch-notification">
                    <ap-content key="{{ 'personal.details.firstNames.error.mismatch' | apKeyOverride: contentKeyMap() }}"></ap-content>
                </ap-notification>
            </ap-grid-col>
        </ap-grid-row>
    }
    <ap-grid-row>
        <ap-grid-col [sm]="3">
            <ap-input
                [label]="'personal.details.insertion.label' | apKeyOverride: contentKeyMap() | apContent"
                name="insertion"
                autocomplete="additional-name"
                formControlName="insertion"
                [messages]="insertionErrorMessages"
                [trim]="true"
                data-testid="insertion"
            >
            </ap-input>
        </ap-grid-col>
        <ap-grid-col [sm]="9">
            <ap-input
                [label]="'personal.details.lastName.label' | apKeyOverride: contentKeyMap() | apContent"
                name="lastName"
                autocomplete="family-name"
                (hasDiacritics)="diacriticsChange($event, 'lastName')"
                apDiacriticsNormalizeFormValue
                formControlName="lastName"
                [messages]="lastNameErrorMessages"
                [trim]="true"
                data-testid="last-name"
            >
            </ap-input>
        </ap-grid-col>
    </ap-grid-row>
    @if (hasDiacritics()) {
        <ap-notification status="warning" data-bb="diacritic-notification">
            @if (personalNameHasDiacritics() && !lastNameHasDiacritics()) {
                <ap-content
                    [params]="{ personalName: getPersonalName() }"
                    key="{{ 'personal.details.diacritics.message.firstNames' | apKeyOverride: contentKeyMap() }}"
                ></ap-content>
            }
            @if (!personalNameHasDiacritics() && lastNameHasDiacritics()) {
                <ap-content
                    [params]="{ customerName: getLastName() }"
                    key="{{ 'personal.details.diacritics.message.lastName' | apKeyOverride: contentKeyMap() }}"
                ></ap-content>
            }
            @if (personalNameHasDiacritics() && lastNameHasDiacritics()) {
                <ap-content
                    [params]="{ personalName: getPersonalName(), customerName: getLastName() }"
                    key="{{ 'personal.details.diacritics.message.full' | apKeyOverride: contentKeyMap() }}"
                ></ap-content>
            }
        </ap-notification>
    }
</form>
